import { FC, useMemo } from 'react'

import { ArtworkNode, PackageNode } from 'gql'
import { useScreenClass } from '~hooks'

import Quantity from './quantity'
import Sort from './sort'
import ToggleVip from './vip'
import ToggleVipTickets from './vip-tickets'
import AfterpayMessage from '../afterpay-message'

import styles from './Menu.module.scss'

type EventMenuProps = {
  tevoId: number
  packageInfo?: Array<Pick<PackageNode, 'id' | 'isTicket'>>
} & Pick<ArtworkNode, 'eventExtendedStatus'>

const Menu: FC<EventMenuProps> = ({ tevoId, packageInfo, eventExtendedStatus }) => {
  const { isDesktop } = useScreenClass()

  const isTevoEvent = !!tevoId || !!packageInfo.some((p) => p.isTicket)
  const hasPackages = !!packageInfo.some((p) => !p.isTicket)

  const displayVipPackagesToggle = useMemo(() => {
    if (hasPackages && !isTevoEvent) {
      return false
    }

    if (!hasPackages && isTevoEvent) {
      return false
    }

    return true
  }, [isTevoEvent, hasPackages])

  return (
    <div className={styles.menu}>
      {eventExtendedStatus !== 'canceled' && (
        <>
          {displayVipPackagesToggle && <ToggleVip />}

          {!displayVipPackagesToggle && <ToggleVipTickets />}

          <Quantity />
          <Sort />
          {isDesktop && (
            <div className={styles.afterpay}>
              <AfterpayMessage />
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default Menu
